"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const malty_atoms_button_1 = require("@carlsberggroup/malty.atoms.button");
const malty_atoms_icon_1 = require("@carlsberggroup/malty.atoms.icon");
const malty_atoms_text_1 = require("@carlsberggroup/malty.atoms.text");
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const malty_utils_consts_1 = require("@carlsberggroup/malty.utils.consts");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const Pagination_helper_1 = require("./Pagination.helper");
const Pagination_styled_1 = require("./Pagination.styled");
const Pagination_types_1 = require("./Pagination.types");
const MIN_ALLOWED_VALUE = 1;
const Pagination = ({ count, currentPage, onChange, siblingCount, type = Pagination_types_1.PaginationType.Default, dataTestId, isWhite = false }) => {
    const isInput = type === Pagination_types_1.PaginationType.Input;
    const isCompact = type === Pagination_types_1.PaginationType.Compact;
    const isLastPage = currentPage === count;
    const isFirstPage = currentPage === MIN_ALLOWED_VALUE;
    // TODO: in case this component needs to be used in SSR, include validation for the window or
    // include a custom hook to check for the screen size
    // https://github.com/CarlsbergGBS/cx-component-library/pull/629#discussion_r1187538517
    const buttonSize = window.innerWidth <= 768 ? malty_atoms_button_1.ButtonSize.Small : malty_atoms_button_1.ButtonSize.Medium;
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    const [provisionalInputValue, setProvisionalInputValue] = (0, react_1.useState)(currentPage);
    const [inputValue, setInputValue] = (0, react_1.useState)(currentPage);
    const displayedPages = (0, Pagination_helper_1.usePagination)({
        totalPageCount: count,
        siblingCount,
        currentPage,
        isDefault: type === Pagination_types_1.PaginationType.Default
    });
    (0, react_1.useEffect)(() => {
        setInputValue(currentPage);
    }, [currentPage]);
    const onPageClick = (targetPage) => {
        onChange(targetPage, Pagination_types_1.PaginationTrigger.PageNr);
    };
    const onPageKeyUp = (pageNr, trigger = Pagination_types_1.PaginationTrigger.PageNr) => (event) => {
        if (event.key === malty_utils_consts_1.EventKeys.ENTER || event.key === malty_utils_consts_1.EventKeys.SPACE) {
            event.preventDefault();
            onChange(pageNr, trigger);
        }
    };
    const onPrevious = () => {
        if (type === Pagination_types_1.PaginationType.Input) {
            onChange(inputValue - 1);
            return setInputValue(inputValue - 1);
        }
        return onChange(currentPage - 1, Pagination_types_1.PaginationTrigger.Prev);
    };
    const onNext = () => {
        if (type === Pagination_types_1.PaginationType.Input) {
            onChange(inputValue + 1);
            return setInputValue(inputValue + 1);
        }
        return onChange(currentPage + 1, Pagination_types_1.PaginationTrigger.Next);
    };
    const onPreviousKeyUp = () => {
        onPageKeyUp(currentPage - 1, Pagination_types_1.PaginationTrigger.Prev);
    };
    const onNextKeyUp = () => {
        onPageKeyUp(currentPage + 1, Pagination_types_1.PaginationTrigger.Next);
    };
    const handleOnInputChange = ({ currentTarget: { value } }) => {
        setInputValue(value !== '' ? Number(value) : value);
    };
    const handleAssignInputValue = ({ currentTarget: { value } }) => {
        let newValue = Number(value === '' ? provisionalInputValue : value);
        if (newValue > count) {
            newValue = count;
        }
        else if (newValue < MIN_ALLOWED_VALUE) {
            newValue = MIN_ALLOWED_VALUE;
        }
        if (newValue !== provisionalInputValue) {
            onChange(newValue, Pagination_types_1.PaginationTrigger.PageNr);
        }
        setInputValue(newValue);
        setProvisionalInputValue(newValue);
    };
    const handleOnKeyDown = (event) => {
        if (event.key === malty_utils_consts_1.EventKeys.ENTER) {
            handleAssignInputValue(event);
        }
    };
    const renderContent = () => {
        var _a;
        if (isInput) {
            return (react_1.default.createElement(Pagination_styled_1.StyledInputPagination, { theme: theme },
                react_1.default.createElement(Pagination_styled_1.StyledInput, { theme: theme, "data-testid": `${dataTestId}-input`, value: inputValue, onChange: handleOnInputChange, onBlur: handleAssignInputValue, onKeyDown: handleOnKeyDown, max: count, min: MIN_ALLOWED_VALUE, type: "number", "aria-label": `Page ${inputValue}` }),
                react_1.default.createElement(malty_atoms_text_1.Text, { dataQaId: `${dataTestId}-input-count`, textStyle: malty_atoms_text_1.TextStyle.MediumSmallDefault, color: isWhite ? malty_atoms_text_1.TextColor.White : malty_atoms_text_1.TextColor.DigitalBlack, "aria-label": `of ${count}` }, ` / ${count}`)));
        }
        if (isCompact) {
            return (react_1.default.createElement("li", null,
                react_1.default.createElement(malty_atoms_text_1.Text, { dataQaId: `${dataTestId}-pagination-compact`, textStyle: malty_atoms_text_1.TextStyle.SmallDefault, color: isWhite ? malty_atoms_text_1.TextColor.White : malty_atoms_text_1.TextColor.DigitalBlack, "aria-label": `Page ${currentPage} of ${count}` }, `${currentPage} of ${count}`)));
        }
        return ((_a = displayedPages === null || displayedPages === void 0 ? void 0 : displayedPages.map((pageNr) => {
            const isCurrentPage = pageNr === currentPage;
            if (pageNr === Pagination_helper_1.LEFT_DOTS || pageNr === Pagination_helper_1.RIGHT_DOTS) {
                return (react_1.default.createElement("li", { "data-testid": `${dataTestId}-${pageNr}`, key: pageNr, tabIndex: -1 },
                    react_1.default.createElement(Pagination_styled_1.StyledDots, { theme: theme, isWhite: isWhite, "aria-label": "Ellipsis" }, "\u2026")));
            }
            return (react_1.default.createElement("li", { className: "default-pagination", key: pageNr },
                react_1.default.createElement(malty_atoms_button_1.Button, { dataTestId: `${dataTestId}-page-${pageNr}`, style: malty_atoms_button_1.ButtonStyle.Transparent, selected: isCurrentPage, onClick: () => onPageClick(Number(pageNr)), onKeyUp: () => onPageKeyUp(Number(pageNr)), "aria-current": isCurrentPage, "aria-label": isCurrentPage ? `Page ${pageNr}` : `Go to page ${pageNr}`, tabIndex: 0, text: pageNr, negative: isWhite, size: buttonSize })));
        })) !== null && _a !== void 0 ? _a : null);
    };
    return (react_1.default.createElement(Pagination_styled_1.StyledContainer, { "data-testid": dataTestId, isWhite: isWhite, theme: theme },
        react_1.default.createElement("ul", null,
            react_1.default.createElement("li", null,
                react_1.default.createElement(malty_atoms_button_1.Button, { dataTestId: `${dataTestId}-button-previous`, style: malty_atoms_button_1.ButtonStyle.Transparent, disabled: isFirstPage, tabIndex: isFirstPage ? -1 : 0, onClick: onPrevious, onKeyUp: onPreviousKeyUp, icon: malty_atoms_icon_1.IconName.ChevronLeft, size: buttonSize, negative: isWhite, "aria-label": "Go to previous page" })),
            renderContent(),
            react_1.default.createElement("li", null,
                react_1.default.createElement(malty_atoms_button_1.Button, { dataTestId: `${dataTestId}-button-next`, style: malty_atoms_button_1.ButtonStyle.Transparent, disabled: isLastPage, tabIndex: isLastPage ? -1 : 0, onClick: onNext, onKeyUp: onNextKeyUp, icon: malty_atoms_icon_1.IconName.ChevronRight, size: buttonSize, negative: isWhite, "aria-label": "Go to next page" })))));
};
exports.Pagination = Pagination;
//# sourceMappingURL=Pagination.js.map